import { render } from "./TaxInformationSectionAttachment.vue?vue&type=template&id=af0e37b4"
import script from "./TaxInformationSectionAttachment.vue?vue&type=script&lang=js"
export * from "./TaxInformationSectionAttachment.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__